import { StationsAutocomplete } from "@/features/infra";
import {
    Button,
    Dialog,
    DialogBody,
    DialogContainer,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    Form,
} from "@/shared/components";
import { useForm } from "react-hook-form";

type StationFormData = {
    stationCode: string;
};

type AddMedewerkersStationDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onSubmit: (stationCode: string) => void;
};

export function AddMedewerkersStationDialog({ open, onOpenChange, onSubmit }: AddMedewerkersStationDialogProps) {
    const form = useForm<StationFormData>();

    const stationCode = form.watch("stationCode");

    const handleSubmit = (data: StationFormData) => {
        if (!data.stationCode) return;
        onSubmit(data.stationCode);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContainer className="max-w-md">
                <DialogHeader>
                    <DialogTitle>Station handmatig toevoegen</DialogTitle>
                </DialogHeader>
                <Form {...form}>
                    <form onSubmit={(e) => void form.handleSubmit(handleSubmit)(e)}>
                        <DialogBody className="space-y-4">
                            <DialogDescription>Selecteer een station om medewerkers voor op te roepen.</DialogDescription>
                            <StationsAutocomplete
                                form={form}
                                name="stationCode"
                                placeholder="Zoek station..."
                                nlStationsOnly
                                data-testid="vos-stations-add-station"
                            />
                        </DialogBody>

                        <DialogFooter>
                            <div className="flex flex-row justify-end gap-2">
                                <Button type="button" variant="secondary" onClick={() => onOpenChange(false)}>
                                    Annuleren
                                </Button>
                                <Button type="submit" variant="primary" disabled={!stationCode}>
                                    Toevoegen
                                </Button>
                            </div>
                        </DialogFooter>
                    </form>
                </Form>
            </DialogContainer>
        </Dialog>
    );
}
